angular.module('impactx.cancellation').controller('CancelRequestRejectCommentController', [
    '$scope',
    '$mdDialog',
    'trns',
    'themeFactory',
    'TranslationService',
    CancelRequestRejectCommentController]);

function CancelRequestRejectCommentController($scope, $mdDialog, trns, themeFactory, TranslationService)
{
    $scope.title = trns.rejectComment;
    $scope.saveLabel = trns.reject;
    $scope.abortLabel = TranslationService.get('abort');
    $scope.commentLabel = TranslationService.get('comment');
    $scope.theme = themeFactory.getTheme();
    $scope.comment = '';

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    
    this.answer = function ()
    {
        $mdDialog.hide($scope.comment);
    };
}